import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../context/auth-context.jsx';
import SystemSectionTabsLayout from '../../../shared/ui/system-section-tabs/system-section-tabs-layout.jsx';
import { hasPermission } from '../model/permission-visibility.js';

const SYSTEM_SECURITY_TAB_DEFINITIONS = [
  {
    key: 'events',
    labelKey: 'systemNav.eventsTab',
    to: '/system/security/events',
    permission: 'system.events.view',
  },
  {
    key: 'alerts',
    labelKey: 'systemNav.securityAlertsTab',
    to: '/system/security/alerts',
    permission: 'security_alert.view',
  },
  {
    key: 'policy',
    labelKey: 'systemNav.securityPolicyTab',
    to: '/system/security/policy',
    permission: 'security_alert.view',
  },
  {
    key: 'action-log',
    labelKey: 'systemNav.actionLogTab',
    to: '/system/security/action-log',
    permission: 'audit_log.view',
  },
  {
    key: 'access-control',
    labelKey: 'systemNav.accessControlTab',
    to: '/system/security/access-control',
    permission: 'system.manage',
  },
];

function useSystemSecurityTabs() {
  const { t } = useTranslation();
  const { permissions } = useAuth();

  return SYSTEM_SECURITY_TAB_DEFINITIONS
    .filter((tab) => hasPermission(permissions, tab.permission))
    .map((tab) => ({
      key: tab.key,
      label: t(tab.labelKey),
      to: tab.to,
    }));
}

export function SystemSecurityIndexRedirect() {
  const tabs = useSystemSecurityTabs();
  return <Navigate to={tabs[0]?.to || '/dashboard'} replace />;
}

function SystemSecurityLayout() {
  const tabs = useSystemSecurityTabs();
  return <SystemSectionTabsLayout tabs={tabs} />;
}

export default SystemSecurityLayout;
